import Button from "../../elements/buttons/Button";   

import bkg from '../../../images/planes/bkgPlan.png';


const GiftCard = ({precio, link, copyLink, copy, className, classNameLink}) =>(
    <>
        <article className={`GiftCardPlan ${className}`}>
            <div className="GiftCardPlan-top">
                <h2>GIFT <span>CARD</span></h2>
                <h3>BS {precio}</h3>
            </div>
            <div className="GiftCardPlan-bottom">
            <p>{copy}</p>
            <Button link={link} className={classNameLink} copy={copyLink} />
            <img src={bkg} className="bkg" />
            </div>
        </article>
    </>
)

export default GiftCard;